import axios from 'axios';
import {ICrudGetAction, ICrudPutAction, IPayloadResult} from 'react-jhipster';

import {cleanEntity} from 'app/shared/util/entity-utils';
import {FAILURE, REQUEST, SUCCESS} from 'app/shared/reducers/action-type.util';

import {defaultValue, IDriver} from 'app/shared/model/driver.model';
import {IPayload} from "react-jhipster/src/type/redux-action.type";
import {IDriverCompact} from 'app/shared/model/driver-compact.model';

export const ACTION_TYPES = {
  FETCH_DRIVER_LIST: 'driver/FETCH_DRIVER_LIST',
  FETCH_DRIVER_BY_FILTER: 'driver/FETCH_DRIVER_BY_FILTER',
  FETCH_DRIVER: 'driver/FETCH_DRIVER',
  FETCH_DRIVER_COMPACT: 'driver/FETCH_DRIVER_COMPACT',
  CREATE_DRIVER: 'driver/CREATE_DRIVER',
  UPDATE_DRIVER: 'driver/UPDATE_DRIVER',
  DELETE_DRIVER: 'driver/DELETE_DRIVER',
  UPDATE_NEIGHBOR_VILLAGES: 'driver/UPDATE_NEIGHBOR_VILLAGES',
  RESET_MODAL: 'driver/RESET_MODAL',
  RESET: 'driver/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IDriver>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
  deleteFailure: false,
  compactEntities: [] as ReadonlyArray<IDriverCompact>,
  compactLoading: false,
};

export type DriverState = Readonly<typeof initialState>;

// Reducer

export default (state: DriverState = initialState, action): DriverState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_DRIVER_LIST):
    case REQUEST(ACTION_TYPES.FETCH_DRIVER_BY_FILTER):
    case REQUEST(ACTION_TYPES.FETCH_DRIVER):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.FETCH_DRIVER_COMPACT):
      return {
        ...state,
        errorMessage: null,
        compactLoading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_DRIVER):
    case REQUEST(ACTION_TYPES.UPDATE_DRIVER):
    case REQUEST(ACTION_TYPES.DELETE_DRIVER):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_DRIVER_LIST):
    case FAILURE(ACTION_TYPES.FETCH_DRIVER_BY_FILTER):
    case FAILURE(ACTION_TYPES.FETCH_DRIVER):
    case FAILURE(ACTION_TYPES.CREATE_DRIVER):
    case FAILURE(ACTION_TYPES.UPDATE_DRIVER):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case FAILURE(ACTION_TYPES.FETCH_DRIVER_COMPACT):
      return {
        ...state,
        compactLoading: false,
        errorMessage: action.payload,
      };
    case FAILURE(ACTION_TYPES.DELETE_DRIVER):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        deleteFailure: true,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_DRIVER_LIST):
    case SUCCESS(ACTION_TYPES.FETCH_DRIVER_BY_FILTER):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_DRIVER):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_DRIVER_COMPACT):
      return {
        ...state,
        compactLoading: false,
        compactEntities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_DRIVER):
    case SUCCESS(ACTION_TYPES.UPDATE_DRIVER):
    case SUCCESS(ACTION_TYPES.UPDATE_NEIGHBOR_VILLAGES):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_DRIVER):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET_MODAL:
      return {
        ...state,
        deleteFailure: false,
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/drivers';

// Actions

export const getEntities: (page?, size?, sort?, countryId?) => IPayload<IDriver> | IPayloadResult<IDriver> = (page?, size?, sort?, countryId?) => {

  const requestUrl = (sort.split(",")[0] === "district" || sort.split(",")[0] === "council") ? `${apiUrl}${`?page=${page}&size=${size}&countryId=${countryId}&SortKey=${sort.split(",")[0]}&OrderKey=${sort.split(",")[1]}`}`
    : `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}&countryId=${countryId}` : ''}`;

  return {
    type: ACTION_TYPES.FETCH_DRIVER_LIST,
    payload: axios.get<IDriver>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export interface IDriverFilter {
  name?: string;
  countryId?: string;
  regionId?: string;
  districtId?: string;
  activePage?: number;
  sort?: {
    sortOrder?: string;
    sortType?: string;
  };
}

export const getEntitiesByFilter = (filter: IDriverFilter) => {
  let requestUrl = `${apiUrl}-by-filter?cacheBuster=${new Date().getTime()}`;

  if (filter.activePage !== undefined) {
    requestUrl += `&page=${filter.activePage}&size=25`;
  }

  if (filter.sort) {
    requestUrl += `&sort=${filter.sort.sortType},${filter.sort.sortOrder}`;
  }

  if (filter.name) {
    requestUrl += `&name=${encodeURIComponent(filter.name)}`;
  }

  if (filter.countryId) {
    requestUrl += `&countryId=${filter.countryId}`;
  }

  if (filter.regionId) {
    requestUrl += `&regionId=${filter.regionId}`;
  }

  if (filter.districtId) {
    requestUrl += `&districtId=${filter.districtId}`;
  }

  return {
    type: ACTION_TYPES.FETCH_DRIVER_BY_FILTER,
    payload: axios.get<IDriver>(requestUrl),
  };
};


export const getEntity: ICrudGetAction<IDriver> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_DRIVER,
    payload: axios.get<IDriver>(requestUrl),
  };
};


export const getDriverByName: (searchString, countryId, page) => IPayload<IDriver> | IPayloadResult<IDriver> = (searchString, countryId, page) => {
  const requestUrl = 'api/search/search-driver-by-name';
  return {
    type: ACTION_TYPES.FETCH_DRIVER_LIST,
    payload: axios.get<IDriver>(`${requestUrl + '/' + searchString + '/' + countryId}?page=${page}&cacheBuster=${new Date().getTime()}`),
  };
};


export const createEntity: ICrudPutAction<IDriver> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_DRIVER,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IDriver> = entity => async dispatch => {
  const requestUrl = `${apiUrl}/${entity.id}`;
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_DRIVER,
    payload: axios.put(requestUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: (id, country?) => IPayload<IDriver> | IPayloadResult<IDriver> = (id, countryId?) => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_DRIVER,
    payload: axios.delete(requestUrl),
  });
  countryId ? dispatch(getEntities(0, 25, "id", countryId)) : dispatch(getEntities())
  // dispatch(getEntities());
  return result;
};

export const getDriversCompact = (countryId?) => {
  const requestUrl = `${apiUrl}/compact`;
  const params = new URLSearchParams();
  if (countryId) params.append('countryId', countryId);

  return {
    type: ACTION_TYPES.FETCH_DRIVER_COMPACT,
    payload: axios.get<IDriverCompact[]>(`${requestUrl}?${params.toString()}`),
  };
};

export const resetModal = () => ({
  type: ACTION_TYPES.RESET_MODAL
});

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
